import createAdaptBackboneView from "./backbone/createAdaptBackboneView";

const adaptBackboneView = createAdaptBackboneView();

export default adaptBackboneView;
